import { useRef } from 'react';

import type { SearchMapHandle } from 'components/marketplace/map/types';

export const useMapRefs = () => {
  const mapRef = useRef<SearchMapHandle | null>(null);

  return { mapRef };
};
